import Sliders from "../../components/Sliders";

export default function SlidersScreen(){
return <Sliders />
}